export default "__VITE_ASSET__ClLAISsm__"